import { useState, type FormEvent } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { post, ApiError } from '../api/client'

export default function Login() {
  const { login }  = useAuth()
  const navigate   = useNavigate()
  const location   = useLocation()
  const from       = (location.state as { from?: string })?.from ?? '/'

  const [email,    setEmail]    = useState('')
  const [password, setPassword] = useState('')
  const [error,    setError]    = useState<string | null>(null)
  const [loading,  setLoading]  = useState(false)

  async function handleSubmit(e: FormEvent) {
    e.preventDefault()
    setError(null)
    setLoading(true)
    try {
      const data = await post<{ token: string }>('/auth/login', { email, password })
      login(data.token)
      navigate(from, { replace: true })
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Login failed.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '1rem',
    }}>
      <div style={{ width: '100%', maxWidth: 400 }}>

        {/* Brand */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.65rem', marginBottom: '2rem', justifyContent: 'center' }}>
          <span style={{
            width: 40, height: 40, borderRadius: 12,
            background: 'linear-gradient(135deg, var(--pb-primary) 0%, var(--pb-primary-2) 100%)',
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            color: '#fff', fontSize: '1.1rem',
            boxShadow: '0 8px 24px -8px rgba(109,93,252,0.55)',
          }}>
            <i className="bi bi-layers" />
          </span>
          <span style={{ fontWeight: 800, fontSize: '1.4rem', letterSpacing: '-0.02em', color: 'var(--pb-text)' }}>
            numerus
          </span>
        </div>

        {/* Card */}
        <div className="pb-card" style={{ padding: '2rem' }}>
          <div style={{ marginBottom: '1.75rem' }}>
            <h1 style={{ fontWeight: 700, fontSize: '1.2rem', letterSpacing: '-0.01em', margin: 0, color: 'var(--pb-text)' }}>
              Sign in
            </h1>
            <p style={{ color: 'var(--pb-muted)', fontSize: '0.88rem', margin: '0.25rem 0 0' }}>
              Enter your credentials to continue
            </p>
          </div>

          {error && (
            <div style={{
              background: 'rgba(239,68,68,0.1)',
              border: '1px solid rgba(239,68,68,0.25)',
              borderRadius: 10,
              padding: '0.6rem 0.9rem',
              fontSize: '0.85rem',
              color: 'var(--pb-danger)',
              marginBottom: '1.25rem',
            }}>
              <i className="bi bi-exclamation-circle me-2" />{error}
            </div>
          )}

          <form onSubmit={handleSubmit} noValidate>
            <div style={{ marginBottom: '1rem' }}>
              <label style={{ display: 'block', fontSize: '0.82rem', fontWeight: 600, color: 'var(--pb-text)', marginBottom: '0.4rem' }}>
                Email
              </label>
              <input
                type="email"
                className="pb-input form-control"
                value={email}
                onChange={e => setEmail(e.target.value)}
                autoComplete="email"
                autoFocus
                required
                placeholder="you@example.com"
              />
            </div>

            <div style={{ marginBottom: '1.5rem' }}>
              <label style={{ display: 'block', fontSize: '0.82rem', fontWeight: 600, color: 'var(--pb-text)', marginBottom: '0.4rem' }}>
                Password
              </label>
              <input
                type="password"
                className="pb-input form-control"
                value={password}
                onChange={e => setPassword(e.target.value)}
                autoComplete="current-password"
                required
                placeholder="••••••••"
              />
            </div>

            <button
              type="submit"
              className="pb-btn-primary"
              style={{ width: '100%', padding: '0.65rem', fontSize: '0.92rem' }}
              disabled={loading || !email || !password}
            >
              {loading
                ? <><span className="spinner-border spinner-border-sm me-2" style={{ width: '0.85rem', height: '0.85rem', borderWidth: '0.15em' }} />Signing in…</>
                : 'Sign in'}
            </button>
          </form>
        </div>
      </div>
    </div>
  )
}
